module.exports = __webpack_public_path__ + "static/media/coming-soon-border.cdf0d132.png";